import { AfterViewInit, Directive, ElementRef, HostListener, Input, OnInit, ViewContainerRef } from "@angular/core";
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationExtras, Router } from "@angular/router";
import { environment } from "@env/environment";
import { isTeamsWindow } from "@env/msal";
import { Logger } from "@timeghost/web-api";

declare const window: Window;
const log = new Logger("TeamsExternaLinkDirective");

export const TeamUtils = {
	parseUrl(
		router: Router,
		relativeTo?: ActivatedRoute | ActivatedRouteSnapshot,
		routerLink?: string[],
		options: NavigationExtras = {}
	) {
		const rl = router.serializeUrl(
			router.createUrlTree(
				routerLink || [],
				!!relativeTo ? <NavigationExtras>{ relativeTo, ...options } : options
			)
		);
		const url = environment.clientUrl;
		const ul = new URL(rl.toString(), url);
		return new URL(`${url}/${ul.pathname.indexOf("/") === 0 ? ul.pathname.slice(1) : ul.pathname}`, url).toString();
	},
	clickLink(url: string, kind: "app" | "external" = "app") {
		const teamsApp = window.microsoftTeams?.app;
		const openViaTeams = () => {
			if (typeof teamsApp?.openLink === "function") {
				void teamsApp.openLink(url);
				return true;
			}
			return false;
		};
		const openViaWindow = () => {
			try {
				return !!window.open(url, "_blank", "noopener,noreferrer");
			} catch {
				return false;
			}
		};
		// Own app (checkout): keep user gesture via window.open. Docs: do not use app.openLink
		// to navigate to your own app. External https: app.openLink is the host API.
		if (kind === "external") {
			if (openViaTeams()) {
				return;
			}
			openViaWindow();
			return;
		}
		if (openViaWindow()) {
			return;
		}
		openViaTeams();
	},
};

@Directive({
	selector: "[routerLink][teamsExternalLink],[routerLink][teams-external]",
})
export class TeamsExternaLinkDirective implements OnInit, AfterViewInit {
	@Input("routerLink")
	private _rl: any | any[];
	private openingExternal = false;
	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private ref: ElementRef<HTMLElement>,
		private viewContainer: ViewContainerRef
	) {}
	ngAfterViewInit(): void {
		if (window.teamsMobile) this.ref.nativeElement?.remove();
	}
	ngOnInit(): void {}
	@HostListener("click", ["$event"])
	onRouterClick(ev: Event) {
		if (!isTeamsWindow()) {
			return true;
		}
		ev.stopPropagation();
		ev.preventDefault();
		if (this.openingExternal) {
			return false;
		}
		if (window.teamsMobile) {
			this.viewContainer.clear();
			this.viewContainer.element.nativeElement?.remove();
			return false;
		}
		this.openingExternal = true;
		TeamUtils.clickLink(
			TeamUtils.parseUrl(this.router, this.route, typeof this._rl === "string" ? [this._rl] : this._rl)
		);
		window.setTimeout(() => {
			this.openingExternal = false;
		}, 1500);
		return false;
	}
}
